import { webp, rem2px } from "@al/rc-util";

function isImg(path: string): boolean {
  return /\w.(png|jpg|jpeg|svg|webp|gif|bmp)/i.test(path);
}

type Options = {
  format?: "webp";
  width?: string | number;
  height?: string | number;
};

export function formatImageUrl(imageUrl: string, options: Options): string {
  if (!imageUrl || !isImg(imageUrl)) {
    return imageUrl;
  }

  return webp.transToWebpUrl({
    source: imageUrl,
    width: (rem2px(options.width) || 360) as number,
    height: rem2px(options.height) as number,
  });
}
